import { render } from "./CardPartnerRequest.vue?vue&type=template&id=d0978d48"
import script from "./CardPartnerRequest.vue?vue&type=script&lang=js"
export * from "./CardPartnerRequest.vue?vue&type=script&lang=js"

import "./CardPartnerRequest.vue?vue&type=style&index=0&id=d0978d48&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__